import { Text, tokens } from "@fluentui/react-components";

export function EmptyState({ message }: { message: string }) {
  return (
    <div
      style={{
        padding: 48,
        textAlign: "center",
        color: tokens.colorNeutralForeground2,
      }}
    >
      <Text size={400}>{message}</Text>
    </div>
  );
}
